var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-yellow-600 rounded-md text-white flex items-center w-min",class:[_vm.textSizeClass, _vm.paddingClasses]},[_c('fa-icon',{staticClass:"mr-1",attrs:{"fixed-width":"","icon":"gift"}}),_vm._v(" "+_vm._s(_vm.name)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }